import React from "react";
import { cn } from "../../utils/cn";
import {
  baseClasses,
  colorClasses,
  hoverColorClasses,
  hoverShadow,
  LinkType,
} from "./buttonStyles";

interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
  color?: "peach";
  type?: LinkType;
  className?: string;
  target?: string;
  rel?: string;
  download?: boolean;
}

const ExternalLink: React.FC<ExternalLinkProps> = ({
  href,
  children,
  color = "peach",
  type = "primary",
  className,
  target,
  rel,
  download = false,
}) => (
  <a
    href={href}
    target={target}
    rel={rel}
    download={download}
    className={cn(
      baseClasses,
      colorClasses[color][type],
      "hover:cursor-pointer",
      hoverShadow,
      hoverColorClasses[color][type],
      className,
    )}
  >
    {children}
  </a>
);

export default ExternalLink;
